(function(){
	'use strict';
	var app = angular.module('IndicatorStructure', ['ui.tree','ui.tree-filter']);

	app.filter("trust", ['$sce', function($sce) {
		return function(htmlCode) {
			return $sce.trustAsHtml(htmlCode);
		};
	}]);

	app.filter('getByTag', function() {
		return function(input, id) {
			var i=0, len=input.length;
			for (; i<len; i++) {
				if (+input[i].id == +id) {
					return input[i];
				}
			}
			return null;
		}
	});

	app.controller('IndicatorStructureController', ['$scope', '$filter', '$sce', '$timeout', 'DataService', function ($scope, $filter, $sce, $timeout, DataService) {
		$scope.loading = true;
		$scope.pattern;
		$scope.treeFilter = $filter('uiTreeFilter');

		$scope.availableFields = ['title'];
		$scope.supportedFields = ['title'];

		$scope.filters = {};
		$scope.filterCommunes = {};

		$scope.activeIndicator = false;
		$scope.setActiveIndicator = function(indicator) {
			if(indicator) {
				$scope.activeIndicator = indicator;
			} else {
				$scope.activeIndicator = null;
			}
		};

		$scope.deleteCommuneFilter = function(uid) {
			delete $scope.filterCommunes[uid];
		};

		$scope.deleteFilter = function(key, uid) {
			delete $scope.filters[key][uid];
			if(!Object.keys($scope.filters[key]).length) delete $scope.filters[key];
		};

		$scope.copyToCommune = function(indicator, category) {
            var confirmed;
			if(indicator.hasOwnProperty('set')) {
				confirmed = confirm('Sind Sie sicher, dass Sie das Indikator-Set "' + indicator.title + '" in den Bereich "' + category.title + '" kopieren wollen?');
				if(confirmed) {
					$scope.loading = true;
					DataService.copyToCommune(indicator.uid, category.id, 1)
						.then(function(data){
							$scope.activeIndicator = null;
							if(data == 'indicator.error.duplicatedCommuneKey') {
								$scope.addError('Ein Indikator-Set mit diesem Key existiert bereits.');
							} else {
								$scope.addSuccess('Das Indikator-Set wurde erfolgreich in die Kommune kopiert.');
							}
							$scope.loading = false;
						});
				}
			} else {
				confirmed = confirm('Sind Sie sicher, dass Sie den Indikator "' + indicator.title + '" in den Bereich "' + category.title + '" kopieren wollen?');
				if(confirmed) {
					$scope.loading = true;
					DataService.copyToCommune(indicator.uid, category.id, 0)
						.then(function(data){
							$scope.activeIndicator = null;
							if(data == 'indicator.error.duplicatedCommuneKey') {
								$scope.addError('Ein Indikator mit diesem Key existiert bereits.');
							}else {
								$scope.addSuccess('Der Indikator wurde erfolgreich in die Kommune kopiert.');
							}
							$scope.loading = false;
						});
				}
			}
		};

		$scope.countByProperty = function(property, value, actualObjectList) {
			var count = 0;
			angular.forEach(actualObjectList, function(indicator){
				if(property == 'commune') {
					if(indicator[property].uid == value) {
						count += 1;
					}
				} else if(indicator[property][value]) {
					count += 1;
				}

			});
			return count;
		};

		$scope.addError = function(error){
			$scope.error = error;
			$timeout(function(){ $scope.error = ''; }, 3000);
		};

		$scope.addSuccess = function(successMessage){
			$scope.successMessage = successMessage;
			$timeout(function(){ $scope.successMessage = ''; }, 3000);
		};

		$scope.loadList = function() {
			DataService.list()
				.then(function (data) {
					$scope.indicators = data;

					// define Tags
					var tags = {};
					var productTags = {};
					var communes = {};
					angular.forEach(data, function(indicator, key){
						angular.forEach(indicator.tags, function (tag, uid) {
							tags[uid] = tag;
						});
						angular.forEach(indicator.productTags, function (productTag, uid) {
							productTags[uid] = productTag;
						});

						if(indicator.commune) communes[indicator.commune.uid] = indicator.commune.name;
					});

					$scope.tags = tags;
					$scope.productTags = productTags;
					$scope.communes = communes;
					$scope.loading = false;
				});

			DataService.categoryTree()
				.then(function (data) {
					$scope.data = data;
					console.info(data);
				});
		};

		$scope.getFullTree = function(){
			DataService.fullTree()
				.then(function (data) {
					console.info(data);
					$scope.fullTree = data;

					// define Tags
					var tags = {};
					var productTags = {};
					var communes = {};
					angular.forEach(data, function(indicator, key){
						angular.forEach(indicator.tags, function (tag, uid) {
							tags[uid] = tag;
						});
						angular.forEach(indicator.productTags, function (productTag, uid) {
							productTags[uid] = productTag;
						});

						if(indicator.commune) communes[indicator.commune.uid] = indicator.commune.name;
					});

					$scope.tags = tags;
					$scope.productTags = productTags;
					$scope.communes = communes;
					$scope.loading = false;
				});
		};

		$scope.toggleSupport = function (propertyName) {
			return $scope.supportedFields.indexOf(propertyName) > -1 ?
				$scope.supportedFields.splice($scope.supportedFields.indexOf(propertyName), 1) :
				$scope.supportedFields.push(propertyName);
		};
	}]);

	app.filter('searchCommune', function() {
		return function(indicators, filterCommunes) {
			if(filterCommunes && Object.keys(filterCommunes).length) {
				var result = {};
				angular.forEach(indicators, function(indicator, key) {
					if (indicator.commune && indicator.commune.uid in filterCommunes) {
						result[key] = indicator;
					}
				});

				return result;
			} else {
				return indicators;
			}
		}
	})
	.filter('highlight', function($sce) {
		return function(text, phrase) {
			if (phrase) text = text.replace(new RegExp('('+phrase+')', 'gi'),
				'<span class="highlighted">$1</span>');

			return $sce.trustAsHtml(text)
		}
	});
})();
